import { render, staticRenderFns } from "./admin-section-image-with-text.vue?vue&type=template&id=6f344871&scoped=true"
import script from "./admin-section-image-with-text.vue?vue&type=script&lang=js"
export * from "./admin-section-image-with-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f344871",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
